import React from 'react';

export default () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M43 43H5V8.8l38-3.6V43z" fill="#fff" />
    <g opacity=".3" fill="#005CB7">
      <path
        opacity=".3"
        d="M11 14H5v2.4h6V14zM8 17.6H5V20h3v-2.4zM43 11h-6v2h6v-2zM36 11h-6v2h6v-2zM43 8h-3v2h3V8zM39 14h-6v2h6v-2zM39 8h-6v2h6V8zM43 29h-6v14h6V29zM37 24a5 5 0 10-10 0v5h-6v4h-8v-6h8v-2h-8a4 4 0 118 0v-1a5 5 0 10-10 0v5H5v14h24V25a4 4 0 118 0v-1z"
      />
    </g>
    <path
      d="M43 43H5V8.8l38-3.6V43z"
      stroke="#005CB7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32 19a5 5 0 00-5 5v19h10V24a5 5 0 00-5-5v0zM21 25H11v-1a5 5 0 015-5v0a5 5 0 015 5v1zM3 9l42-4M21 25H11v8h10v-8z"
      stroke="#005CB7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
